import { useEffect, useRef } from 'react';
import useAnalyticsClient from '../client/use-analytics-client';
import buildIdentityProps from './identity';
import { getQueryParams } from '../client/config';
import { getLocale } from '../../helpers/locale';

export default function useAnalyticsIdentity() {
  const client = useAnalyticsClient();
  const identifiedRef = useRef(false);

  useEffect(() => {
    if (identifiedRef.current || !client) return;

    const params = getQueryParams();
    const userProfileId = params.userProfileId || params.username;

    if (!userProfileId) return;

    identifiedRef.current = true;
    client.setCommonProps(buildIdentityProps(params, getLocale() || 'en-AU'));
    client.identify();
  }, [client]);
}
